import { GatewayControlState } from './states/gateway-control.state';

export const gatewayControlState = [GatewayControlState];
